















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class OdpReadErrorDialog extends Vue {
    @Prop() private isOdpReadError!: boolean;
    @Prop() private handleClose!: () => void;
    @Prop() private errorText?: string;

    // TODO propsの値が初期値に使われた後はdataとpropsの間で値が同期されないので
    // getterとsetterを算出プロパティに定義して回避
    // 参考:https://qiita.com/simezi9/items/c27d69f17d2d08722b3a
    private get hasOdpReadError() {
        return this.isOdpReadError;
    }

    private set hasOdpReadError(v: boolean) {
        this.handleCloseClick();
    }

    private handleCloseClick() {
        if (this.handleClose) {
            this.handleClose();
        }
    }
}
